import { render, staticRenderFns } from "./_about.vue?vue&type=template&id=773a8270"
import script from "./_about.vue?vue&type=script&lang=js"
export * from "./_about.vue?vue&type=script&lang=js"
import style0 from "./_about.vue?vue&type=style&index=0&id=773a8270&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports